module.exports = {"id":"217802","name":"Fábio Sturgeon","rating":"73","photo":"./data/images/photos/3/217802.png","club":{"name":"Vit. Guimarães","logo":"./data/images/clubs/Vit.Guimaraes.png"},"positions":["MG","MD","BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FabioSturgeon0.json
// module id = 1350
// module chunks = 0